import * as React from 'react'
import { useSnapshot } from 'valtio'
import { controlState } from '../../../store/controlState.ts'
import { mapState, setMyPosition } from '../../../store/mapState.ts'
import { MyMarker } from './MyMarker'

export const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
export const TrackMyLocation: React.FC = () => {

    const [watching, setWatching] = React.useState(false)

    const position = (useSnapshot(mapState) as typeof mapState).myPosition
    const color = useSnapshot(controlState).myPositionColor

    const successCallback = (_pos: any) => {
        // console.log('[Geo] getCurrentPosition success:', _pos.coords.latitude, _pos.coords.longitude)
        mapState.locationEnabled = true
    }
    const errorCallback = (error: any) => {
        console.error('[Geo] getCurrentPosition error:', error.code, error.message)
    }
    React.useEffect(() => {
        // console.log('[Geo] navigator.geolocation available:', !!navigator.geolocation)
        if (navigator.geolocation) {
            if (navigator.permissions?.query) {
                // console.log('[Geo] querying permissions...')
                void navigator.permissions.query({name: 'geolocation'}).then(function (result) {
                    // console.log('[Geo] permission state:', result.state)
                    if (result.state == 'granted' || result.state === 'prompt') {
                        navigator.geolocation.getCurrentPosition(successCallback, errorCallback)
                        startTracking()
                    } else if (result.state == 'denied') {
                        // console.warn('[Geo] permission denied')
                        window.alert('To see your location on the map, enable location services in your devices settings')
                    }
                    result.onchange = function () {
                        // console.log('[Geo] permission changed to:', result.state)
                    }
                })
            } else {
                // console.log('[Geo] permissions API not available, starting tracking directly')
                startTracking()
            }
        } else {
            console.warn('[Geo] navigator.geolocation not supported')
        }
    }, [])

    const startTracking = () => {
        // console.log('[Geo] startTracking called, watching:', watching)
        if (navigator.geolocation) {
            if (!watching) {
                navigator.geolocation.watchPosition(
                    updatePosition,
                    (err) => console.error('[Geo] watchPosition error:', err.code, err.message)
                )
                // console.log('[Geo] watchPosition started')
                setWatching(true)
            }
        } else {
            console.warn('[Geo] geolocation not supported in startTracking')
        }
    }

    const updatePosition = (position: any) => {
        // console.log('[Geo] updatePosition:', position.coords.latitude, position.coords.longitude, 'accuracy:', position.coords.accuracy)
        const update = new window.google.maps.LatLng(position.coords.latitude, position.coords.longitude)
        setMyPosition(update)
    }

    const _color = typeof color === 'string' ? color : '#000'
    return <MyMarker position={position} color={_color}/>
}

